export type { TrailsPageProps } from "./trails-page";
export { TrailsPage } from "./trails-page";
